import type { ReactNode, VoidFunctionComponent } from 'react';

import PackageLocator from '../../issues/PackageLocator';
import type { LocatorParts } from '../../../../../shared/Locator';

import DrawerLoading from './Loading';

import styles from './VulnerabilitiesDrawer.module.less';

type Props = {
  isLoading?: boolean;
  title: string;
  locatorParts: LocatorParts | null;
  badgesSlot?: ReactNode;
};

/**
 * VulnerabilityDrawerHeader is the top header section
 * for the vuln drawer, which includes the title, vulnbadge and CVE.
 */
const VulnerabilityDrawerHeader: VoidFunctionComponent<Props> = ({
  isLoading,
  title,
  locatorParts,
  badgesSlot,
}) => (
  <header className={styles.header}>
    {isLoading ? <DrawerLoading.Header /> : (
      <>
        <div className={styles.severityInfo}>
          {badgesSlot}
        </div>
        <h3 className={styles.title}>
          {title}
        </h3>
        {locatorParts && (
          <PackageLocator
            locatorParts={locatorParts}
            isPrefixDisplayed
          />
        )}
      </>
    )}
  </header>
);

export default VulnerabilityDrawerHeader;
